import React, { Component } from "react";
import LoaderModal from "../../../../modal/LoaderModal";
import { CONFIG } from "../../../../../config";
import accountManagement from "../../../../../apis/accountManagement";
import Fab from "@material-ui/core/Fab";
import PrintIcon from "@material-ui/icons/Print";
import GroupIcon from "@material-ui/icons/Group";

class RekapTa_Sma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            alertShow: false,
            resMessage: "",
            params: this.props.match.params,
            siswa: [],
            profesional_siswa: 0,
            profesional_prosen: 0,
            enterpreneur_siswa: 0,
            enterpreneur_prosen: 0,
            study_siswa: 0,
            study_prosen: 0,
            sekolah: "-",
            kelas: "-",
            kelasParalel: "",
            title: "-",
            penjurusan: null,
        };
    }

    async componentDidMount() {
        if (this.props.match.params !== undefined) {
            this.fetchReport();
            if (this.state.params.idSekolah !== "null") {
                this.setState({ title: " SEKOLAH" });
            }
            if (this.state.params.idKelas !== "null") {
                this.setState({ title: " KELAS" });
            }
            if (this.state.params.idKelasParalel !== "null") {
                this.setState({ title: " PARALEL" });
            }
        }
    }

    fetchReport = async () => {
        this.setState({ isFetching: true });
        const response = await accountManagement
            .get(CONFIG.GET_REKAP_TA, {
                params: {
                    idJadwalProfilCbt: this.state.params.idJadwalCbt,
                    idSekolah: this.state.params.idSekolah === "null" ? null : this.state.params.idSekolah,
                    idKelas: this.state.params.idKelas === "null" ? null : this.state.params.idKelas,
                    idKelasParalel: this.state.params.idKelasParalel === "null" ? null : this.state.params.idKelasParalel,
                    kodeAspek: this.state.params.kodeAspek,
                },
            })
            .catch(function (error) {
                alert(error);
            });
        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    siswa: response.data.data.siswa,
                    sekolah: response.data.data.sekolah,
                    kelas: response.data.data.kelas,
                    kelasParalel: response.data.data.kelasParalel,
                    profesional_siswa: response.data.data.grafik.profesional.siswa,
                    profesional_prosen: response.data.data.grafik.profesional.prosentase,
                    enterpreneur_siswa: response.data.data.grafik.enterpreneur.siswa,
                    enterpreneur_prosen: response.data.data.grafik.enterpreneur.prosentase,
                    study_siswa: response.data.data.grafik.study.siswa,
                    study_prosen: response.data.data.grafik.study.prosentase,
                    penjurusan: response.data.data.penjurusan,
                });
            }

            (function () {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = "/assets/js/easypiechart-data.js";
                document.getElementsByTagName("head")[0].appendChild(script);
            })();
            this.setState({ isFetching: false });
        }
    };

    print() {
        window.print();
    }

    render() {
        const { siswa, sekolah, title, penjurusan } = this.state;
        const style = {
            margin: 0,
            top: "auto",
            right: 20,
            bottom: 20,
            left: "auto",
            position: "fixed",
        };
        let kelas;
        if (this.props.match.params.idKelas !== "null") {
            kelas = this.state.kelas;
        }
        if (this.props.match.params.idKelasParalel !== "null") {
            kelas = this.state.kelas + "-" + this.state.kelasParalel;
        }
        require('./RekapTa.css')
        return (
            <>
                <LoaderModal isFetching={this.state.isFetching} />
                <div className="">
                    <div className="cardLine">
                        {/* header */}
                        <div className="pnl-header">
                            <div className="card-page">
                                <span style={{
                                    fontSize: '26px',
                                    color: '#FFF',
                                    fontWeight: 500,
                                    fontFamily: 'lucida grande'
                                }}>01</span>
                            </div>
                            <div className="pnl-date">
                                https://eduprime.co.id
                            </div>
                        </div>
                        <div className="header-first-page" style={{ padding: '0px' }}>
                            <div className="text-header" style={{ padding: '0px' }}>
                                <div className="title-header2" style={{ color: '#015E56' }}>REPORT {title}</div>
                                <div className="label-sub-tit">
                                    <span className="sub-title-header" style={{ color: '#FFF' }}>Specific Talent Analysis - Penjurusan</span>
                                </div>
                            </div>
                            <div className="image-header">
                                <div className="logo-edu">
                                    <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                                </div>
                                <div className="logo-an">
                                    <img src="/assets/image/LOGO_AN_2.png" width={"100%"} style={{ height: '33px', width: '148px' }} />
                                </div>
                            </div>
                        </div>

                        <div className="pnl-profile">
                            <div className="card-profile">
                                <div>
                                    <img src="/assets/image/icon-sekolah.svg" width="60px" alt="" />
                                </div>
                                <div>
                                    <span className="label-profile-name">Nama Sekolah</span>
                                    <p className="label_prosentase">{sekolah}</p>
                                </div>
                            </div>
                            <div className="card-profile">
                                <div>
                                    <img src="/assets/image/icon-person.svg" width="60px" alt="" />
                                </div>
                                <div>
                                    <span className="label-profile-name">Jumlah Siswa</span>
                                    <p className="label_prosentase">{siswa.length}</p>
                                </div>
                            </div>
                        </div>

                        {penjurusan !== null && (
                            <>
                                <div className="card-profile">
                                    <div className="pnl-flex">
                                        <div style={{ width: '50%' }}>
                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">MIPA</span>
                                                        <span className="p-siswa-light">{penjurusan.mipa.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.mipa.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.mipa.prosen + "%", backgroundColor: "#F2994A" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Ilmu Bahasa</span>
                                                        <span className="p-siswa-light">{penjurusan.bahasa.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.bahasa.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.bahasa.prosen + "%", backgroundColor: "#9795CF" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Tanaman</span>
                                                        <span className="p-siswa-light">{penjurusan.tanaman.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.tanaman.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.tanaman.prosen + "%", backgroundColor: "#1DB9C3" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Ilmu Ekonomi</span>
                                                        <span className="p-siswa-light">{penjurusan.ekonomi.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.ekonomi.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.ekonomi.prosen + "%", backgroundColor: "#FF8474" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Ilmu Hewani</span>
                                                        <span className="p-siswa-light">{penjurusan.hewan.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.hewan.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.hewan.prosen + "%", backgroundColor: "#7DACE4" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Ilmu Sosial Humaniora</span>
                                                        <span className="p-siswa-light">{penjurusan.soshum.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.soshum.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.soshum.prosen + "%", backgroundColor: "#A0C1B8" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        <div style={{ width: '50%' }}>
                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Ilmu Kedokteran</span>
                                                        <span className="p-siswa-light">{penjurusan.dokter.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.dokter.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.dokter.prosen + "%", backgroundColor: "#6D739D" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Agama dan Filsafat</span>
                                                        <span className="p-siswa-light">{penjurusan.filsafat.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.filsafat.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.filsafat.prosen + "%", backgroundColor: "#16C79A" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Ilmu Kesehatan</span>
                                                        <span className="p-siswa-light">{penjurusan.kesehatan.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.kesehatan.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.kesehatan.prosen + "%", backgroundColor: "#FEC260" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Seni, Desain dan Media</span>
                                                        <span className="p-siswa-light">{penjurusan.seni.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.seni.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.seni.prosen + "%", backgroundColor: "#D597CE" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Ilmu Teknik</span>
                                                        <span className="p-siswa-light">{penjurusan.teknik.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.teknik.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div className="progress-bar-new progress-bar-mi" role="progressbar" style={{ width: penjurusan.teknik.prosen + "%", backgroundColor: "#93D9A3" }} aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div className="persentase_siswa" style={{ display: 'flex', gap: '10px' }}>
                                                        <span className="label_prosentase">Ilmu Pendidikan</span>
                                                        <span className="p-siswa-light">{penjurusan.pendidikan.jumlah} Anak</span>
                                                    </div>
                                                    <span className="p-siswa-bold">{penjurusan.pendidikan.prosen}%</span>
                                                </div>
                                                <div className="bg-grey">
                                                    <div className="progress-new skill-bar">
                                                        <div
                                                            className="progress-bar-new progress-bar-mi"
                                                            role="progressbar"
                                                            style={{ width: penjurusan.pendidikan.prosen + "%", backgroundColor: "#6ACAFC" }}
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="card-profile" style={{ padding: '0px' }}>
                            <table className="table table-hover tbl-mpl-siswa">
                                <thead>
                                    <tr>
                                        <th width="1%">No.</th>
                                        <th width="20%">Nama</th>
                                        <th width="10%">Kelas</th>
                                        <th>MIPA</th>
                                        <th>
                                            ILM <br />
                                            TAN
                                        </th>
                                        <th>
                                            ILM <br />
                                            HWN
                                        </th>
                                        <th>
                                            ILM <br />
                                            KED
                                        </th>
                                        <th>
                                            ILM <br />
                                            KES
                                        </th>
                                        <th>
                                            ILM <br />
                                            TEK
                                        </th>
                                        <th>
                                            ILM <br />
                                            BHS
                                        </th>
                                        <th>
                                            ILM <br />
                                            EKO
                                        </th>
                                        <th>
                                            ILM <br />
                                            SOSH
                                        </th>
                                        <th>
                                            AGM <br />
                                            FIL
                                        </th>
                                        <th>
                                            SEN <br />
                                            DSG
                                        </th>
                                        <th>
                                            ILM <br />
                                            PEND
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {siswa.map((s, i) => (
                                        <tr>
                                            <td>{i + 1}</td>
                                            <td>{s.nama_siswa}</td>
                                            <td>{s.nama_kelas_paralel}</td>
                                            <td>{s.nilaiMipa}</td>
                                            <td>{s.nilaiTanam}</td>
                                            <td>{s.nilaiHewan}</td>
                                            <td>{s.nilaiDokter}</td>
                                            <td>{s.nilaiKesehatan}</td>
                                            <td>{s.nilaiTeknik}</td>
                                            <td>{s.nilaiBahasa}</td>
                                            <td>{s.nilaiEko}</td>
                                            <td>{s.nilaiSoshum}</td>
                                            <td>{s.nilaiFilsafat}</td>
                                            <td>{s.nilaiSeni}</td>
                                            <td>{s.nilaiPend}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>




                    <Fab color="primary" id="btn-print" style={style} onClick={() => window.print()}>
                        <PrintIcon />
                    </Fab>
                </div >
            </>
        );
    }
}

export default RekapTa_Sma;
